<template>
  <div class="jrfw">
    <div class="searchDiv">
      <div class="searchmodel">
        <el-input
          v-model="queryParams.searchValue"
          @keyup.enter.native="getList"
          placeholder="请输入关键字搜索">
          <i
            slot="suffix"
            class="el-input__icon el-icon-search"
            @click="getList('')"></i>
        </el-input>
      </div>
    </div>
    <div class="table">
      <el-table
        header-row-class-name="tableHeader"
        :data="list0"
        style="width: 100%">
        <el-table-column width="400" align="center" prop="cid" label="登记编号">
        </el-table-column>
        <el-table-column
          width="400"
          align="center"
          prop="address"
          label="融资地区">
        </el-table-column>
        <el-table-column
          width="200"
          align="center"
          prop="dyname"
          label="抵押申请人">
        </el-table-column>
        <el-table-column
          width="200"
          align="center"
          prop="type"
          label="抵押物类型">
        </el-table-column>
        <el-table-column
          width="300"
          align="right"
          header-align="center"
          prop="amount"
          label="贷款金额(元)">
          <template slot-scope="scope">
            {{ Number(scope.row.amount).toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="registertime" label="登记时间">
        </el-table-column>
      </el-table>
      <el-pagination
        style="text-align: right; margin-top: 10px"
        prev-text="上一页"
        next-text="下一页"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-size="queryParams.pagesize"
        :current-page="queryParams.pageNum"
        layout="prev, pager, next,total"
        :total="total"></el-pagination>
    </div>
  </div>
</template>

<script>
import { financingMsgList } from '@/api/金融服务'
export default {
  data() {
    return {
      list0: [],
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        searchValue: '',
      },
      total: 0,
    }
  },
  created() {
    this.getList()
  },
  methods: {
    handleCurrentChange(num) {
      this.queryParams.pageNum = num
      this.getList()
    },
    handleSizeChange(size) {
      this.queryParams.pagesize = size
      this.getList()
    },
    getList() {
      financingMsgList(this.queryParams).then((res) => {
        this.list0 = res.data.rows
        this.total = res.data.total
        console.log(res)
      })
    },
  },
}
</script>

<style scoped>
.jrfw {
  display: flex;
  flex-direction: column;
  width: 1860px;
  margin: 0 auto;
  min-height: 630px;
}
.table {
  display: flex;
  flex-direction: column;
}
.searchmodel /deep/.el-input {
  font-size: 22px;
  /* border: 1px solid red; */
  text-align: left;
}

.searchmodel /deep/.el-input__inner {
  height: 50px;
  width: 300px;
  border: 1px solid #747474;
  border-radius: 10px;
  /* font-size: 16px; */
}

.searchmodel {
  /* margin-left: 500px; */
  width: 300px;
  margin: 10px 0;
}
</style>
